import React from 'react';
import { motion } from 'framer-motion';
import { Plus, Pill, Calendar, FileText, Heart, Droplet } from 'lucide-react';

const QuickActionsPanel = ({ onAddSymptom, onAddMedication, onAddAppointment, onAddNote, onAddBloodPressure, onAddBloodSugar }) => {

  const actions = [
    { 
      id: 'symptom', 
      label: 'Add Symptom', 
      icon: Plus, 
      color: '#A2DAD3',
      onClick: onAddSymptom
    },
    { 
      id: 'medication', 
      label: 'Add Medication', 
      icon: Pill, 
      color: '#F9A7A7',
      onClick: onAddMedication
    },
    { 
      id: 'bp', 
      label: 'Blood Pressure', 
      icon: Heart, 
      color: '#F9A7A7',
      onClick: onAddBloodPressure
    },
    { 
      id: 'bs', 
      label: 'Blood Sugar', 
      icon: Droplet, 
      color: '#F9D6A7',
      onClick: onAddBloodSugar
    },
    { 
      id: 'note', 
      label: 'Add Note', 
      icon: FileText, 
      color: '#A7C7F9',
      onClick: onAddNote
    },
    { 
      id: 'appointment', 
      label: 'Appointment', 
      icon: Calendar, 
      color: '#C7A7F9',
      onClick: onAddAppointment
    },
  ];

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ delay: 0.15 }}
      className="card"
      data-testid="quick-actions-panel"
    >
      <h2 className="text-lg sm:text-xl font-semibold mb-4" style={{ color: '#A2DAD3' }}>Quick Actions</h2>
      <div className="grid grid-cols-3 sm:grid-cols-3 md:grid-cols-6 gap-2 sm:gap-4">
        {actions.map((action) => {
          const Icon = action.icon;
          return (
            <button
              key={action.id}
              data-testid={`quick-action-${action.id}`}
              onClick={action.onClick}
              className="flex flex-col items-center justify-center p-3 sm:p-5 rounded-xl transition-all hover:scale-105 min-h-[80px] sm:min-h-[100px]"
              style={{ 
                backgroundColor: `${action.color}15`,
                border: `2px solid ${action.color}`,
              }}
            >
              <Icon size={24} className="sm:w-7 sm:h-7" style={{ color: action.color, marginBottom: '6px', flexShrink: 0 }} />
              <span className="text-[10px] sm:text-xs md:text-sm font-medium text-center leading-tight" style={{ color: '#333', wordWrap: 'break-word', maxWidth: '100%' }}>
                {action.label}
              </span>
            </button>
          );
        })}
      </div>
    </motion.div>
  );
};

export default QuickActionsPanel;
